import store from '@/store'
import axios from 'axios'
import router from '@/router'

const instance = axios.create({
  baseURL: '/', // schedule的服务器地址 http://8.155.168.133:8080   使用nginx 后改为'/'或https://lingdongzhen.com/
  timeout: 30000
})

instance.interceptors.request.use(function (config) {
  const excludedUrls = ['/api/register', '/api/forgot_password', '/api/send_verification_code', '/api/sms_login', '/api/login']
  if (!excludedUrls.some(url => config.url.includes(url))) {
    const token = store.state.token
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
      config.headers.platform = 'H5'
    } else {
      // 没有 token，弹出提示“请先登录”，不跳转页面
      if (typeof window !== 'undefined' && window.$message) {
        window.$message.warning('请先登录')
      } else {
        // 没有 $message 的环境下使用 alert
        alert('请先登录')
      }
      // 没有 token，跳登录（但避免已在登录页时重复跳转）
      // 方案1：
      // if (!router.currentRoute.value.path.startsWith('/loginRegister')) {
      //  router.push('/loginRegister')
      // }
      // 方案2：  请求拦截器 中也跳转了登录页（比如 token 不存在时），同样加上 redirect
      // 在请求拦截器中也保存来源
      const currentPath = router.currentRoute.value.fullPath
      if (!currentPath.startsWith('/loginRegister')) {
        router.push({
          path: '/loginRegister',
          query: { redirect: currentPath }
        })
      }
      // 注意：此处未 reject，会导致请求继续发送（可能不理想）
      // 更佳做法：直接 reject
      return Promise.reject(new Error('No token, redirecting to login'))
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

instance.interceptors.response.use(
  function (response) {
    const res = response.data
    // 处理业务状态码
    // if (res.status !== 200) {
    // 特别处理业务 401：Token 过期或无效
    if (res.status === 401) {
      store.dispatch('logout')
      const currentPath = router.currentRoute.value.fullPath
      if (!currentPath.startsWith('/loginRegister')) {
        router.push({
          path: '/loginRegister',
          query: { redirect: currentPath }
        })
      }
      // 注意：即使跳转了，也要 reject，避免上层误认为请求成功
      return Promise.reject(new Error(res.message || '登录已过期，请重新登录'))
    }

    // 其他业务错误
    // return Promise.reject(new Error(res.message || '请求失败'))
    // }
    // 原代码  方案1：
    return res
  }, function (error) {
    // 处理网络错误或 HTTP 状态码 4xx/5xx
    // 处理 401：Token 无效或过期
    if (error.response?.status === 401) {
      // 调用 Vuex 的 logout action，自动清除token、user和localStorage
      store.dispatch('logout')

      // 比如 this.$message 或 全局 Toast
      if (typeof window !== 'undefined' && window.$message) {
        window.$message.warning('登录已过期，请重新登录')
      }

      // 方案跳转1   开始   跳转到登录页
      // if (!router.currentRoute.value.path.startsWith('/loginRegister')) {
      //   router.push('/loginRegister')
      // }

      // 方案跳转2   开始   获取当前路径
      const currentPath = router.currentRoute.fullPath
      // 只有不是登录页时才跳转，避免循环
      if (!currentPath.startsWith('/loginRegister')) {
        // 跳转到登录页，并带上 redirect 参数
        router.push({
          path: '/loginRegister',
          query: { redirect: currentPath }
        })
      }
      // 方案跳转2
    }
    return Promise.reject(error)
  }
)
export default instance

// 成功的数据res = {"status": 200, "message": "success", "data": {"token": token}}
// 失败的数据res = {"status": 200, "message": "登陆失败"}
// 为什么前端要写 const res = response.data？
// 这是因为 Axios 对 HTTP 响应做了封装。
// 当你用 Axios 发起请求时，它返回的 response 对象不是原始 JSON，而是一个包含多个字段的结构体：
// {
//   data: { ... },        // ← 这才是后端返回的 JSON 内容！
//   status: 200,          // HTTP 状态码
//   statusText: "OK",
//   headers: { ... },
//   config: { ... },
//   request: { ... }
// }
// 所以：
// response.data = 后端 jsonify(...) 返回的 JSON 对象
// response.status = HTTP 状态码（如 200、500）
// 为什么前端要 response.data？因为 Axios 把 HTTP 响应封装成一个对象，data字段才是后端返回的 JSON

//   “登录后记住来源页面”
// 用户访问 /videosDownPage
// Token 过期 → 拦截器跳转到 /loginRegister?redirect=%2FvideosDownPage
// 用户登录成功 → 自动跳回 /videosDownPage

// 所有 401（HTTP 或业务）由拦截器统一处理：logout + 跳转登录页
// 如需提示用户，使用 非阻塞 Toast / message，而非 alert
// 移除业务代码中的 401 判断和 showError
